import React from "react";
import SellerHeader from "../../components/SellerHeader";
import ProductForm from "../../components/ProductForm";

const AddProductForm = () => {
  
  return (
    <>
      <SellerHeader />
      <ProductForm />
    </>
  );
};

export default AddProductForm;
